// Funciones y constantes que se pueden utilizar en todo el proyecto

export const escribirLogsEnConsola = 0
// demo I+D
//export const codinsclo = 1067

// parking barcelona port
export const codinsclo = 1097

function escribirLog(mensaje) {
  /* asi puedo controlar la escritura de logs en produccion */  
  if (escribirLogsEnConsola==1)
    console.log(mensaje);

}

function generarUrlBase(){
  /* construyo la url de llamada al rest api a partir del protocolo y nombre del host desde 
    el que se ha activado la pagina web.
    De esta manera me evito errores por falta de protocolo de seguridad y CORS */
  
  return window.location.protocol + '//' + window.location.hostname + '/RestApiPuertoBarcelona';
 
  // return "https://parkingbarcelonaport.com/RestApiPuertoBarcelona";
  //return "https://dev.equinsaparking.com/RestApiPuertoBarcelona";
}


export {escribirLog, generarUrlBase}